<template>
    <div class="admin-tab">
        <wb-datatable
                v-bind="tableProps"
                @addEmit="openDialog"
                @editEmit="openDialog"
                @deleteEmit="openConfirmDialog"
                :searchKey="'name'"
        ></wb-datatable>

        <md-dialog ref="dialog">
            <md-dialog-title>{{isNew ? 'Create documentation' : 'Update documentation'}}</md-dialog-title>
            <md-dialog-content>
                <form @submit.prevent="closeDialog(true)" v-if="documentation">
                    <md-input-container>
                        <label>Name</label>
                        <md-input v-model="documentation.name"></md-input>
                    </md-input-container>
                    <md-input-container>
                        <label>Collection</label>
                        <md-input v-model="documentation.collection"></md-input>
                    </md-input-container>
                    <md-input-container>
                        <multiselect id="docKey"
                                     v-model="selectedKey"
                                     :options="keys"
                                     :multiple="false"
                                     :close-on-select="true"
                                     placeholder="Key"
                                     label="Key"
                        />
                    </md-input-container>
                    <md-input-container v-if="isNew">
                        <label>Position</label>
                        <md-input type="number" v-model="documentation.position"></md-input>
                    </md-input-container>
                    <div>
                        <md-switch id="docSecured" v-model="documentation.secured">Secured</md-switch>
                    </div>
                </form>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-primary" @click="closeDialog(false)">Cancel</md-button>
                <md-button class="md-primary" @click="closeDialog(true)">{{isNew ? 'Create' : 'Update'}}</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog ref="confirmDialog">
            <md-dialog-title>Are you sure you would like to remove this documentation?</md-dialog-title>

            <md-dialog-content>
                Documentation will permanently be removed from the database
            </md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-primary" @click="closeConfirmDialog(false)">Cancel</md-button>
                <md-button class="md-primary" @click="closeConfirmDialog(true)">Delete</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
    import wbDataTable from 'WBDataTable';
    import { mapActions, mapGetters } from 'vuex';
    import Multiselect from 'vue-multiselect';
    import _ from 'underscore';
    import managedata from "../../helpers/managedata";

    export default {
        name: 'AdminDocumentation',
        components: {
            'wb-datatable': wbDataTable,
            Multiselect,
        },
        data() {
            return {
                documentation: null,
                selectedKey: null,
                keys: [],
                isNew: false,
                tableProps: {
                    dataext: [],
                    columns:[
                        {name: 'id', displayName: 'ID', visible: false, type:'number', isEditable: false},
                        {name: 'name', displayName: 'Name', visible: true, type:'string', isEditable: false},
                        {name: 'collection', displayName: 'Collection', visible: true, type:'string', isEditable: false},
                        {name: 'key', displayName: 'Key', visible: true, type:'number', isEditable: false},
                        {name: 'position', displayName: 'Position', visible: true, type:'number', isEditable: false},
                        {name: 'secured', displayName: 'Secured', visible: true, type:'boolean', isEditable: false},
                    ],
                    hasControls: true,
                    allowCreation: true,
                    disableSearch: false,
                    pagination: {
                        size: 50
                    }
                }
            }
        },
        methods: {
            getDocs() {
                managedata.getDocs()
                    .then(resp => {
                        this.tableProps.dataext = resp.body;
                    });
            },
            getDocsKeys() {
                managedata.getDocsKeys()
                    .then(resp => {
                        this.keys = resp.body;
                    });
            },
            openDialog(row) {
                if (row) {
                    this.isNew = false;
                    this.documentation = row;
                    const key = row.key;
                    this.selectedKey = this.keys.find(keyItem => keyItem.Key === key);
                } else {
                    this.isNew = true;
                    this.documentation = {
                        name: null,
                        collection: null,
                        position: null,
                        secured: true,
                    };
                    this.selectedKey = null;
                }
                this.$refs.dialog.open();
            },
            closeDialog(isSaved) {
                if (isSaved) {
                    const actionName = this.isNew ? 'createDoc' : 'updateDoc';
                    const docForRequest = {
                        id: this.documentation.id,
                        name: this.documentation.name,
                        key: this.selectedKey.Key,
                        collection: this.documentation.collection,
                        position: this.documentation.position,
                        secured: this.documentation.secured,
                    };

                    managedata[actionName](this.isNew ? docForRequest : {doc: docForRequest})
                        .then(() => {
                            this.getDocs();
                        });
                }
                this.$refs.dialog.close();
                this.documentation = null;
                this.selectedKey = null;
            },
            openConfirmDialog(row) {
                this.documentation = row;
                this.$refs.confirmDialog.open();
            },
            closeConfirmDialog(isConfirmed) {
                if (isConfirmed) {
                    managedata.deleteDoc(this.documentation.id)
                        .then(() => {
                            this.getDocs();
                        });
                }
                this.$refs.confirmDialog.close();
            },
        },
        mounted() {
            this.getDocs();
            this.getDocsKeys();
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>

<style>
    .md-dialog .md-input-container .multiselect__tags input, .md-dialog .md-input-container .multiselect__tags textarea {
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// AdminDocumentations.vue?835c0fa8